import $ from 'jquery'
export default {
    getURLParameters(obj) {
        const params = new URLSearchParams(obj || {});
        const query = params.toString();
        return query ? `?${query}` : '';
    },
    globalPostLoad() {
        $('a[href^="https://"]').attr('target', '_blank');
        $('a[href^="http://"]').attr('target', '_blank');
    }
}
